import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import React from 'react';
import FormWithDescription from '../../FormWithDescription';

export default function DefaultAddPicker({
  value,
  setValue,
  title,
  description,
  label,
  marginTop,
  isWide,
}) {
  return (
    <div>
      <FormWithDescription
        title={title}
        description={description}
        marginTop={marginTop}
        isWide={isWide}
      >
        <FormControl variant="standard" fullWidth className="ml-1">
          <FormGroup>
            <FormControlLabel
              labelPlacement="end"
              control={
                <Switch
                  checked={value}
                  onChange={() => setValue(!value)}
                  color="primary"
                />
              }
              label={label}
            />
          </FormGroup>
        </FormControl>
      </FormWithDescription>
    </div>
  );
}
